import { prescriptionForm } from './prescriptionForm/reducer'

export const reducers = {
  prescriptionForm,
}
